/**
 * Post-job flow routing helpers. The legacy validate/build-payload path was
 * replaced by ./post-job/post-job-machine.ts (v2 employer contract, PRD §7);
 * only the origin-aware success routing remains.
 */
export type PostJobOrigin = 'jobs' | 'open-roles';

export function getPostJobDoneHref(origin: PostJobOrigin) {
  return origin === 'open-roles' ? '/(employer)/company/open-roles' : '/(employer)/jobs';
}
